import { concat } from '@ember/helper';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import t from 'ember-intl/helpers/t';
import ForcJournalEventBaseComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import PublicComment from 'parog-web/components/layout/medics-web/public-comment';
import type { Behaviour } from 'parog-web/models/lifestyle-declared-journal-event';
import LifestyleDeclaredJournalEvent from 'parog-web/models/lifestyle-declared-journal-event';

export default class LifestylCoachingEditionComponent extends ForcJournalEventBaseComponent {
  static override forcDisplayName = 'Hygiène de vie';
  static override fullComponentId = 'lifestyle/coaching-edition-form';
  static override journalEventClass = LifestyleDeclaredJournalEvent;

  availableKeys = ['sleep', 'physicalActivity', 'food', 'drugs', 'stress'];
  commentaryPrefix = 'commentary-';
  override journalEventProperties = ['behaviours'];
  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  override computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();

    // Retrieve and rebuild an array from the value in the changeset.
    payload.behaviours = this.availableKeys
      .map(key => {
        if (!this.model[key]) return;
        return {
          key: key,
          comment: this.model[this.getCommentKey(key)]
        };
      })
      .filter(behavior => behavior != null);

    return payload;
  }

  getCommentKey(key: string) {
    return this.commentaryPrefix + key;
  }

  override retrieveModel() {
    const model = super.retrieveModel();

    // If there is a previous JE comming from our JournalEventRetrievalStrategies
    // the model should have a behaviours property
    if (model.behaviours) {
      // Inject the content of the array directly in our model
      (model.behaviours as Behaviour[]).forEach(behavior => {
        model[behavior.key] = true;
        model[this.getCommentKey(behavior.key)] = behavior.comment;
      });
    }

    return model;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        {{#each this.availableKeys as |key|}}
          <div class='field'>
            <Form.Checkbox
              @labelName={{t 'lifestyle.coaching' key=key}}
              @payloadKey={{key}}
            />
          </div>
          {{#if (changesetGet this.changeset key)}}
            <div class='field'>
              <PublicComment
                @form={{Form}}
                @labelName='Précisions'
                @propertyName={{concat this.commentaryPrefix key}}
              />
            </div>
            <br />
          {{/if}}
        {{/each}}
      </:content>
    </Provider>
  </template>
}
